import { gql } from "@apollo/client";

export const GET_QUESTION = gql`
  query ($question: ID!) {
    question(question: $question) {
      id
      questionType
      popularity
      timesAnswered
      averageMark
      createdBy {
        id
      }
      bestAnswers {
        id
        answer
      }
      educationLevel {
        id
        level
        yearGroups {
          id
          yearGroup
        }
      }
      yearGroup {
        id
        yearGroup
        educationLevel {
          id
          level
          yearGroups {
            id
            yearGroup
          }
        }
      }
      subject {
        id
        name
        parent {
          id
          name
        }
      }
      tags {
        id
        tag
      }
      questionText
      sourceText
      sourceImages {
        id
        fileUrl
        description
      }
      isPublished
      isComplete
      rating {
        rating
        count
      }
      userReview {
        rating
        comment
      }
      options {
        id
        text
        isCorrect
      }
      markScheme {
        id
        name
        modelAnswerGuidance
        objectives {
          id
          marks
          additionalInstructions
          assessmentObjective {
            id
            focusArea
            description
            identifier
            subject {
              name
            }
          }
          levels {
            minMark
            maxMark
            levelCriteria
          }
        }
      }
    }
  }
`;

export const GET_ALL_QUESTIONS = gql`
  query (
    $searchString: String!
    $educationLevels: [ID]
    $subjects: [ID]
    $fromSameSchool: Boolean
    $userOnly: Boolean
    $published: Boolean
    $quizOnly: Boolean
    $assignmentOrQuizCreate: Boolean
    $questionType: String
    $first: Int
    $after: String
  ) {
    allQuestions(
      searchString: $searchString
      educationLevels: $educationLevels
      subjects: $subjects
      fromSameSchool: $fromSameSchool
      userOnly: $userOnly
      published: $published
      questionType: $questionType
      quizOnly: $quizOnly
      assignmentOrQuizCreate: $assignmentOrQuizCreate
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          isPublished
          questionType
          schoolFeedbackFrameworks {
            educationLevel {
              level
            }
          }
          createdBy {
            id
          }
          yearGroup {
            id
            yearGroup
          }
          educationLevel {
            id
            level
            yearGroups {
              id
              yearGroup
            }
          }
          subject {
            id
            name
            parent {
              id
              name
            }
            subjectAndChildren {
              id
              name
            }
          }
          tags {
            id
            tag
          }
          questionText
          sourceText
          rating {
            rating
            count
          }
          popularity
          isComplete
          options {
            id
            text
            isCorrect
          }
          markScheme {
            id
            name
            tags {
              tag
            }
            modelAnswerGuidance
            objectives {
              id
              marks
              additionalInstructions
              assessmentObjective {
                id
                focusArea
                description
                identifier
                subject {
                  name
                }
              }
              levels {
                minMark
                maxMark
                levelCriteria
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_ASSESSMENT_OBJECTIVES = gql`
  query ($educationLevel: ID!, $subject: ID!) {
    assessmentObjectives(educationLevel: $educationLevel, subject: $subject) {
      id
      identifier
      focusArea
      description
      fruitifyMain
      subject {
        name
      }
    }
  }
`;

export const GET_MOST_USED_ASSESSMENT_OBJECTIVES = gql`
  query ($subject: ID!, $educationLevel: ID!) {
    mostUsedAssessmentObjectives(
      subject: $subject
      educationLevel: $educationLevel
    ) {
      personal {
        usageCount
        objectives {
          assessmentObjective {
            id
            focusArea
            description
            identifier
            subject {
              name
            }
          }
          marks
        }
      }
      trending {
        usageCount
        objectives {
          assessmentObjective {
            id
            focusArea
            description
            identifier
            subject {
              name
            }
          }
          marks
        }
      }
    }
  }
`;

export const GET_MARK_SCHEMES = gql`
  query ($name: String!, $subject: ID!, $educationLevel: ID!) {
    matchedMarkSchemes(
      name: $name
      subject: $subject
      educationLevel: $educationLevel
    ) {
      id
      name
      tags {
        tag
      }
      modelAnswerGuidance
      objectives {
        id
        marks
        additionalInstructions
        assessmentObjective {
          id
          focusArea
          description
          identifier
          subject {
            name
          }
        }
        levels {
          minMark
          maxMark
          levelCriteria
        }
      }
    }
  }
`;
